export default "__VITE_ASSET__z8YNL$q9__"